import { Link } from "react-router-dom";
import a from "./auth.module.css";

export default function AuthPatientTabs({ mode = "login" }) {
  return (
    <div className={a.segmentWrap}>
      <div className={a.segment} role="tablist" aria-label="Вход или регистрация">
        <Link
          to="/login"
          role="tab"
          aria-selected={mode === "login"}
          className={mode === "login" ? a.segmentActive : a.segmentItem}
        >
          Войти
        </Link>
        <Link
          to="/register"
          role="tab"
          aria-selected={mode === "register"}
          className={mode === "register" ? a.segmentActive : a.segmentItem}
        >
          Регистрация
        </Link>
      </div>
    </div>
  );
}
